<template>
  <div>
    <component
      :is="formatIcon"
      :theme="theme"
      :size="size"
      :fill="fill"
      :stroke-width="strokeWidth"
    />
  </div>
</template>

<script>
import {
  Time as CustomTime,
  Checkbox as CustomCheckbox,
  FileStaff,
  TurnAround,
  RightUser,
  ReduceUser,
  Calendar,
  PeopleDeleteOne,
  Transform,
  TakeOff,
  Deposit,
  FinancingOne,
  PrinterTwo,
  Classroom,
  RectangleSmall,
  FileLock,
  AlignTextLeftOne,
  RectangleOne,
  DropDownList,
  RadioTwo,
  UserBusiness,
  CalendarThirty,
  CalendarDot,
  Power,
  Schedule,
  CalendarThirtyTwo,
  AutoWidth,
  FileAddition,
  Word as CustomWord,
} from '@icon-park/vue'

export default {
  components: {
    CustomTime,
    FileStaff,
    TurnAround,
    RightUser,
    ReduceUser,
    Calendar,
    PeopleDeleteOne,
    Transform,
    TakeOff,
    Deposit,
    FinancingOne,
    PrinterTwo,
    Classroom,
    RectangleSmall,
    FileLock,
    AlignTextLeftOne,
    RectangleOne,
    DropDownList,
    RadioTwo,
    CustomCheckbox,
    UserBusiness,
    CalendarThirty,
    CalendarDot,
    Power,
    Schedule,
    CalendarThirtyTwo,
    AutoWidth,
    FileAddition,
    CustomWord,
  },
  props: {
    icon: {
      type: String,
      default: 'check-one',
    },
    theme: {
      type: String,
      default: 'filled',
    },
    size: {
      type: [String, Number],
      default: '28',
    },
    fill: {
      type: String,
      default: '#000000',
    },
    strokeWidth: {
      type: Number,
      default: 3,
    },
  },
  data() {
    return {
      hasChangeIcon: ['time', 'checkbox', 'word'],
    }
  },
  computed: {
    formatIcon() {
      if (this.hasChangeIcon.indexOf(this.icon) !== -1) {
        return `custom-${this.icon}`
      }
      return this.icon
    },
  },
}

</script>

<style lang='scss' scoped>

</style>
